<div class="row">
    <div class="col-6">
        <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study.details.environments.details.title' | translate}}" iconClass="bms-icon bms-mgt-details" [helpKey]="HELP_MANAGE_STUDIES_ENVIRONMENT">
            <ng-container>
                <jhi-variables-table [variables]="environmentDetails"
                                     [showInputVariablesColumn]="false"
                                     (onAddEvent)="addVariable($event, VariableTypeEnum.ENVIRONMENT_DETAIL)"
                                     (onRemoveEvent)="detachOrDeleteFilesIfAny($event, VariableTypeEnum.ENVIRONMENT_DETAIL)"
                                     [variableTypeIds]="[VariableTypeEnum.ENVIRONMENT_DETAIL]"
                                     [hiddenVariablesFromTable]="HIDE_FROM_VARIABLES_TABLE"
                                     [hiddenVariablesFromSelector]="HIDE_FROM_VARIABLES_SELECTOR"
                                     [disableVariablesFromSelector]="studyEditorContext.existingStudyLevelVariableIds"
                                     [showReorderButtons]="false"
                                     [showAddButton]="principal.hasAnyAuthorityDirect(ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS)"
                                     [showDeleteButton]="principal.hasAnyAuthorityDirect(ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS)"
                ></jhi-variables-table>
            </ng-container>
        </jhi-collapsible>
    </div>
    <div class="col-6">
        <jhi-collapsible customClass="d-inline-flex p-2 h5 fw-bold" heading="{{'study.details.environments.conditions.title' | translate}}" [img]="'content/images/conditions.svg'" [helpTooltipKey]="'study-editor.study-environments.help.tooltip.environment-conditions'">
            <ng-container>
                <jhi-variables-table [variables]="environmentConditions"
                                     [showInputVariablesColumn]="false"
                                     (onAddEvent)="addVariable($event, VariableTypeEnum.ENVIRONMENT_CONDITION)"
                                     (onRemoveEvent)="detachOrDeleteFilesIfAny($event, VariableTypeEnum.ENVIRONMENT_CONDITION)"
                                     [variableTypeIds]="[VariableTypeEnum.ENVIRONMENT_CONDITION]"
                                     [hiddenVariablesFromTable]="HIDE_FROM_VARIABLES_TABLE"
                                     [hiddenVariablesFromSelector]="HIDE_FROM_VARIABLES_SELECTOR"
                                     [showReorderButtons]="false"
                                     [showAddButton]="principal.hasAnyAuthorityDirect(ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS)"
                                     [showDeleteButton]="principal.hasAnyAuthorityDirect(ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS)"
                ></jhi-variables-table>
            </ng-container>
        </jhi-collapsible>
    </div>
</div>
<div class="row pt-3">
    <div class="col-6 d-flex align-items-center">
        <span class="fw-bold me-2" jhiTranslate="study-editor.study-environments.number.of.environments">Specify the number of environments for this study:</span>
        <input class="form-control d-inline-block" type="number" name="numberOfEnvironments" id="numberOfEnvironments"
               [(ngModel)]="newNumberOfenvironments"
               [disabled]="isDesignAlreadyGenerated() || !principal.hasAnyAuthorityDirect(MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS)"
               min="1" max="100" value="1" style="width: 100px; display: inline-block;"/>
        @if (isDesignAlreadyGenerated()) {
            <button class="btn btn-link d-inline-block ms-2" (click)="addInstanceClicked()" [disabled]="isReloadPending || !principal.hasAnyAuthorityDirect(MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS)"><i class="fa fa-plus-circle fa-green fa-2x"></i></button>
            <span *ngIf="isReloadPending" class="throbber throbber-btn"></span>
        } @else if (principal.hasAnyAuthorityDirect(MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS)) {
            <button class="btn btn-info d-inline-block ms-2" jhiTranslate="apply" (click)="setNumberOfInstances()">Apply</button>
        }

    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <label class="col-auto" jhiTranslate="global.records.per.page">Records per page:</label>
                <select name="germplasm-table_length" class="form-select form-select-sm ms-2"
                        [(ngModel)]="pageSize"
                        (change)="onPageSizeChange($event)">
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                </select>
            </div>
            <jhi-column-selector [displayedColumns]="displayedColumns"
                                 [columnDataService]="columnDataService"
                                 (reset)="onColumnSelectorReset()"></jhi-column-selector>
        </div>
    </div>
</div>
<div class="container-fluid p-0">
    <!-- Germplasm Entry Table Section -->
    <div *ngIf="showStudyEntriesTable" class="mt-3">
        <!-- Data Table -->
        <div class="table-responsive mt-3">
            <div class="custom-scroll-style" style="min-height: 500px; max-height: 500px; overflow-y: auto; overflow-x: auto;">
                <table id="study-instances-table"
                       class="table table-striped table-bordered table-curved table-editable">
                    <thead class="sticky-header">
                    <tr cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropColumn($event)">
                        @for (column of displayedColumns; track trackColumnsById(column)) {
                            @if (column.selected) {
                                <th [ngClass]="getColumnClass(column)" cdkDrag cdkDragHandle>
                                    {{ column.displayName || column.name }}
                                </th>
                            }
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @for (entry of items; track trackRowsById(entry); let row = $index) {
                            <tr (mouseenter)="setHoveredRow(row)"
                                (mouseleave)="setHoveredRow(null)">
                                @for (column of displayedColumns; track column; let col = $index) {
                                    <td *ngIf="column.selected && column.visible" (click)="selectEditableCell(entry, row, col)"
                                        [class.selected]="editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)"
                                        [class.number-cell]="variableDataTypeIs(column, DataTypeEnum.NUMERIC)"
                                        [class.date-cell]="variableDataTypeIs(column, DataTypeEnum.DATE)"
                                        [class.categorical-cell]="variableDataTypeIs(column, DataTypeEnum.CATEGORICAL)"
                                        [class.error-cell]="getCellData(row, col)?.hasError"
                                        [ngClass]="getCellClass(entry, column)">

                                        @switch (true) {
                                            @case (column.termId === CHECKBOX) {
                                                @if (showDeleteIcon()) {
                                                    <button (click)="deleteInstanceClicked(entry)" class="btn btn-link btn-sm">
                                                        <i class="fa fa-minus-circle fa-red fa-2x"></i>
                                                    </button>
                                                }
                                            }
                                            @case (column.termId === STATIC_COLUMN_FILES) {
                                                @if (isFileButtonVisible(entry)) {
                                                    <button class="btn btn-sm btn-outline-info"
                                                            ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                            [openDelay]="1200"
                                                            (click)="showFiles(entry.trialInstance, null)"><i class="fa fa-file"></i></button>
                                                } @else if (hoveredRow === row) {
                                                    <button class="btn btn-sm btn-outline-info"
                                                            ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                            [openDelay]="1200"
                                                            (click)="showFiles(entry.trialInstance, null)"><i class="fa fa-file"></i></button>
                                                }<!-- Files content -->
                                            }
                                            @case (editingCell?.row === row && editingCell?.col === col && isColumnEditable(column)) {
                                                @if (column.variableType === 'ENVIRONMENT_DETAIL') {
                                                    <jhi-study-inline-editor
                                                            [observationVariable]="column"
                                                            [cellData]="getCellData(row, col)"
                                                            (onBlur)="onCellBlur(entry, column, row, col)"
                                                            (onKeyDown)="onCellKeyDown($event, entry, column, row, col)"
                                                            (selectedLocation)="onCellSelectedLocation($event, entry, column, row, col)"
                                                            [locationSelectClearable]="false"
                                                            [categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'"
                                                            [isCategoricalDescriptionView]="column.termId !== COOPERATOR_ID_TERMID">
                                                    </jhi-study-inline-editor>
                                                }
                                                @if (column.variableType === 'ENVIRONMENT_CONDITION') {
                                                    <jhi-study-inline-editor
                                                            categoricalBindBy="name"
                                                            [observationVariable]="column"
                                                            [cellData]="getCellData(row, col)"
                                                            (onBlur)="onCellBlur(entry, column, row, col)"
                                                            (onKeyDown)="onCellKeyDown($event, entry, column, row, col)"
                                                            (selectedLocation)="onCellSelectedLocation($event, entry, column, row, col)"
                                                            [locationSelectClearable]="false"
                                                            [categoricalDropdownPosition]="row <= 4 ? 'bottom' : 'auto'"
                                                            [isCategoricalDescriptionView]="true">
                                                    </jhi-study-inline-editor>
                                                }
                                            }
                                            @case (column.termId === COOPERATOR_ID_TERMID) {
                                                <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'id':false" [showCopyButton]="false"></truncate-span>
                                            }
                                            @default {
                                                @if (entry.environmentVariables[column.name] && column.variableType === 'ENVIRONMENT_DETAIL') {
                                                    <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'id':true" [showCopyButton]="false"></truncate-span>
                                                }
                                                @if (entry.environmentVariables[column.name] && column.variableType === 'ENVIRONMENT_CONDITION') {
                                                    <truncate-span [textInput]="getCellValue(entry, column) | categoricalDisplayValue:column:'both':true" [showCopyButton]="false"></truncate-span>
                                                }
                                                @if (isFileButtonVisibleForVariable(entry, column.termId?.toString())) {
                                                    <button class="btn btn-sm btn-outline-info float-end"
                                                            ngbTooltip="{{ 'file.manager.open.title' | translate }}"
                                                            [openDelay]="1200"
                                                            (click)="$event.preventDefault(); $event.stopPropagation(); showFiles(entry.variables['OBS_UNIT_ID'].value, column.name)"><i class="fa fa-file"></i></button>
                                                }
                                            }
                                        }
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				<span jhiTranslate="study-editor.pagination.entry-count"
					  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfItems), param3: numberOfItems}"></span>
            </div>

            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfItems"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
